import { render, staticRenderFns } from "./CountDownProduct.vue?vue&type=template&id=4b9f2f4b&scoped=true"
import script from "./CountDownProduct.vue?vue&type=script&lang=js"
export * from "./CountDownProduct.vue?vue&type=script&lang=js"
import style0 from "./CountDownProduct.vue?vue&type=style&index=0&id=4b9f2f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f2f4b",
  null
  
)

export default component.exports